import { render, staticRenderFns } from "./PaymentSurcharge.vue?vue&type=template&id=45c2ed24&scoped=true&"
import script from "./PaymentSurcharge.vue?vue&type=script&lang=ts&"
export * from "./PaymentSurcharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2ed24",
  null
  
)

export default component.exports